import { createClient } from '@supabase/supabase-js';
import { env } from './env';

export const supabase = createClient(env.VITE_SUPABASE_URL, env.VITE_SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

// Propagate the user's access token to the Realtime client every time
// the auth state changes (initial sign-in, token refresh, sign-out).
// Without this, postgres_changes subscriptions run against the `anon`
// role and RLS hides every row — so the bell + desktop notifications
// only update on the 25s React Query poll instead of in real time.
//
// supabase-js v2 attempts this automatically in most paths but the
// guarantee is fragile: a channel created BEFORE the auth state has
// propagated to the realtime client keeps the stale anon token. The
// explicit setAuth here makes it deterministic.
supabase.auth.onAuthStateChange((_event, session) => {
  // null when signed out — passing null tells realtime to drop back
  // to the anon key, which keeps any public-table subscriptions alive
  // and stops the user from receiving their own row events.
  supabase.realtime.setAuth(session?.access_token ?? null);
});

export async function signInWithGoogle() {
  return supabase.auth.signInWithOAuth({
    provider: 'google',
    options: {
      redirectTo: window.location.origin + '/auth/callback',
      // No `hd` param — we allow multiple Workspace domains and validate via team_members + frontend domain check.
      queryParams: { prompt: 'select_account' },
    },
  });
}

export async function signOut() {
  // Clear the cached team_member before the Supabase round-trip so that
  // even if the network sign-out hangs, a tab reload won't hydrate the
  // ghost user into the app. The auth-guard cache is the only side
  // channel here — Supabase's own session is cleared by `auth.signOut()`
  // below.
  try {
    localStorage.removeItem('pa-auth-tm-cache-v1');
  } catch {
    // ignore — quota / private mode / disabled
  }
  return supabase.auth.signOut();
}
